import React from 'react';
import { Card, CardContent, Grid, Skeleton, Typography } from '@mui/material';

const StatCard = ({ label, value, loading }) => {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ py: 2 }}>
        {loading ? (
          <>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={90} height={42} />
          </>
        ) : (
          <>
            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.4 }}>
              {label}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, mt: 0.5 }}>
              {value}
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
};

const SummaryCards = ({ data, loading = false }) => {
  const totalSubmissions = data?.totalSubmissions ?? 0;
  const acceptanceRate = data?.acceptanceRate ?? 0;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <StatCard label="Total Submissions" value={totalSubmissions} loading={loading} />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <StatCard label="Acceptance Rate" value={`${acceptanceRate}%`} loading={loading} />
      </Grid>
    </Grid>
  );
};

export default SummaryCards;
